import { render, staticRenderFns } from "./RegisteredComplaintEmisorCustomer.vue?vue&type=template&id=9f4300d0"
import script from "./RegisteredComplaintEmisorCustomer.vue?vue&type=script&lang=js"
export * from "./RegisteredComplaintEmisorCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports